@if (showBadge) {
  <span i18n="@@app.new" class="badge badge-pill font-weight-600 badge-new">New</span>
}
